export default "__VITE_ASSET__03436949__"